<template>
    <div id="ApplicationLog" class="app-inner">
         <el-tabs v-model="activeName2" type="border-card" @tab-click="handleClick">
        <el-tab-pane label="应用登录日志" name="first">
            <searchTemplate 
            :active = "activeName2"
            @sendStatus="classSelect"
            ref="searchTemplate"
            ></searchTemplate>
            <div class="businessList-container">
                <div class="businessList-container-table">
                            <el-table 
                            ref="multipleTable"
                            :data="itemList"
                            tooltip-effect="dark"
                            style="width: 100%"
                            border
                            id='mytable'
                            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                            >
                            <el-table-column prop="username" label="登录账号" align="center">
                             </el-table-column>
                              <el-table-column prop="appName" label="登录应用" align="center">
                             </el-table-column>
                              <el-table-column  label="所属企业" align="center">
                                    <template slot-scope="scope">
                                  <div>
                                    {{scope.row.businessName || '暂无'}}
                                  </div>
                                    </template>
                             </el-table-column>
                               <el-table-column prop="loginTime" label="登录时间" align="center">
                             </el-table-column>
                              <el-table-column  label="退出时间" align="center">
                                <template slot-scope="scope">
                                  <div>
                                    {{scope.row.logoutTime ? scope.row.logoutTime : '暂无'}}
                                  </div>
                                </template>
                             </el-table-column>
                              <el-table-column  label="登录终端机器码" align="center">
                                <template slot-scope="scope">
                                  <div>
                                    {{scope.row.machineCode ? scope.row.machineCode : '暂无'}}
                                  </div>
                                </template>
                             </el-table-column>
                              <el-table-column prop="remoteAddr" label="登录IP" align="center">
                             </el-table-column>
                            </el-table>
                            
                                <el-pagination
          class="jiange"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageSizes"
          :page-size="PageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
                </div>
            </div>
        </el-tab-pane>
        <el-tab-pane label="应用操作日志" name="second">
             <searchTemplate :active = "activeName2"
              @sendStatus="classSelect"
              ref="searchTemplate1"
             ></searchTemplate>
                  <el-table
                            ref="multipleTable"
                            :data="itemList"
                            tooltip-effect="dark"
                            style="width: 100%"
                            border
                            id='mytable'
                            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                            >
                <el-table-column prop="username" label="用户账号" align="center">
                 </el-table-column>
                  <el-table-column prop="appName" label="操作应用" align="center">
                 </el-table-column>
                  <el-table-column prop="title" label="操作行为" align="center">
                 </el-table-column>
                  <el-table-column prop="createTime" label="操作时间" align="center">
                 </el-table-column>
                </el-table>
                    <el-pagination
          class="jiange"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageSizes"
          :page-size="PageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
        </el-tab-pane>
  </el-tabs>
    </div>
</template>
<script>
import searchTemplate from "@/components/searchTemplate/index.vue"; //筛选公共组件
import {getAppLoginLog} from "@/api/index/index" //应用列表
export default {
    name:'ApplicationLog',
    components: {
        searchTemplate,
    },
    data(){
        return {
           totalNum:0,
        currentPage: 1, //初始页
        PageSize: 10, //每页的数据
        totalCount: 0,
        pageSizes:[10,20,30,40,50,100],
        activeName2: 'first',
        itemList:[],
        startTime:'',
        endTime:'',
        appName:'',
        username:'',
        businessName:'',
        urlType:'appLogin'
        }
    },
    
    created(){
       this.activeName2 == 'first' ? this.type = 'appLogin' : this.type = 'appOperate'  //appLogin表示应用登录日志，appOperate表示应用操作日志
        this.gethisInfo(this.type)
    },
    methods: {
        // 筛选
        classSelect(val,val1,val2,val3){
            this.appName = val
            this.username = val2
            this.businessName = val3
            if(val1){
             this.startTime = val1[0]
            this.endTime =  val1[1]
            }else{
                 this.startTime = ''
            this.endTime =  ''
            }
            this.currentPage = 1
            this.gethisInfo(this.type)
        },
        // 选项卡切换
        handleClick(tab, event){
            this.activeName2 == 'first' ? this.$refs.searchTemplate.reset() : this.$refs.searchTemplate1.reset(); 
            this.currentPage = 1
            this.appName = ''
            this.endTime = ''
            this.startTime = ''
            this.username = ''
            this.businessName = ''
            this.activeName2 == 'first' ? this.type = 'appLogin' : this.type = 'appOperate'  //appLogin表示应用登录日志，appOperate表示应用操作日志
            this.gethisInfo(this.type)
        },
              // 获取列表
        gethisInfo(type){
           
            let params = {
                startTime:this.startTime,
                endTime:this.endTime,
                appName:this.appName,
                username:this.username,
                businessName:this.businessName,
                current: this.currentPage,
                size:this.PageSize,
            }
            getAppLoginLog(params,type)
            .then(res => {
              this.itemList = res.data.records
             this.totalCount = res.data.total;
            })
            .catch(err => {
            })
        },
          handleSizeChange(val) {
       this.PageSize = val
       this.gethisInfo(this.type)
    },
    handleCurrentChange(val) {
      this.currentPage = val
       this.gethisInfo(this.type)
    },
    }
}

</script>
<style lang="scss" scoped>
  .businessList-container {
    .businessList-container-title {
      font-size: 18px;
      color: #409eff;
      background-color: rgba(242, 242, 242, 1);
      padding: 10px 20px;
      .mft {
        cursor: pointer;
      }
    }
    .businessList-container-table {
      margin-top: 20px;
      .el-switch {
        position: relative;
        z-index: 1 !important;
      }
      .el-switch.is-disabled {
        opacity: 1 !important;
      }
    }
    .jiange {
      margin-top: 20px;
    }
  }
</style>